import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"basic\"><a href=\"#basic\"></a> Basic </h1><div class=\"py-5\"> Use <a class=\"fw-bold\" href=\"&lt;?php echo Theme::getPageUrl(&#39;documentation/base/utilities#width-and-height&#39;)?&gt;\" target=\"_blank\">Custom Size Classes</a>  for bullets to set custom width and height: </div><div class=\"py-5\"><div class=\"rounded border p-10 d-flex flex-column flex-wrap\"><div class=\"d-flex\"><div class=\"d-flex align-items-center me-15\"><span class=\"bullet bg-primary h-15px w-25px me-5\"></span> .h-15px .w-25px </div><div class=\"d-flex align-items-center me-15\"><span class=\"bullet bg-primary h-20px w-30px me-5\"></span> .h-20px .w-30px </div><div class=\"d-flex align-items-center\"><span class=\"bullet bg-primary h-30px w-50px me-5\"></span> .h-30px .w-50px </div></div><div class=\"separator my-10\"></div><div class=\"d-flex\"><div class=\"d-flex align-items-center me-15\"><span class=\"bullet bullet-dot bg-primary h-15px w-15px me-5\"></span> .h-15px .w-15px </div><div class=\"d-flex align-items-center me-15\"><span class=\"bullet bullet-dot bg-primary h-20px w-20px me-5\"></span> .h-20px .w-20px </div><div class=\"d-flex align-items-center\"><span class=\"bullet bullet-dot bg-primary h-30px w-30px me-5\"></span> .h-30px .w-30px </div></div><div class=\"separator my-10\"></div><div class=\"d-flex\"><div class=\"d-flex align-items-center me-15\"><span class=\"bullet bullet-vertical bg-primary h-25px w-15px me-5\"></span> .h-25px .w-15px </div><div class=\"d-flex align-items-center me-15\"><span class=\"bullet bullet-vertical bg-primary h-30px w-20px me-5\"></span> .h-30px .w-20px </div><div class=\"d-flex align-items-center\"><span class=\"bullet bullet-vertical bg-primary h-50px w-30px me-5\"></span> .h-50px .w-30px </div></div></div></div>", 3)
const _hoisted_5 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`
        <div class="d-flex align-items-center me-15">
          <span class="bullet bg-primary h-15px w-25px me-5"></span> .h-15px
          .w-25px
        </div>
        <div class="d-flex align-items-center me-15">
          <span class="bullet bg-primary h-20px w-30px me-5"></span> .h-20px
          .w-30px
        </div>
        <div class="d-flex align-items-center">
          <span class="bullet bg-primary h-30px w-50px me-5"></span> .h-30px
          .w-50px
        </div>

        <div class="d-flex align-items-center me-15">
          <span class="bullet bullet-dot bg-primary h-15px w-15px me-5"></span>
          .h-15px .w-15px
        </div>
        <div class="d-flex align-items-center me-15">
          <span class="bullet bullet-dot bg-primary h-20px w-20px me-5"></span>
          .h-20px .w-20px
        </div>
        <div class="d-flex align-items-center">
          <span class="bullet bullet-dot bg-primary h-30px w-30px me-5"></span>
          .h-30px .w-30px
        </div>

        <div class="d-flex align-items-center me-15">
          <span
            class="bullet bullet-vertical bg-primary h-25px w-15px me-5"
          ></span>
          .h-25px .w-15px
        </div>
        <div class="d-flex align-items-center me-15">
          <span
            class="bullet bullet-vertical bg-primary h-30px w-20px me-5"
          ></span>
          .h-30px .w-20px
        </div>
        <div class="d-flex align-items-center">
          <span
            class="bullet bullet-vertical bg-primary h-50px w-30px me-5"
          ></span>
          .h-50px .w-30px
        </div>
        `), 1)
        ]),
        _: 1
      })
    ])
  ]))
}